import type { Draft } from 'immer'
import isArray from 'lodash/isArray'
import keys from 'lodash/keys'

import type { TransferForm } from '@/app/transfers/transfer-create-form'

export type TransferFormFieldPath = Extract<keyof TransferForm, string>
export type TransferFormErrorMap = Record<string, string | undefined>
export type TransferFormFieldValue = TransferForm[TransferFormFieldPath]

export function setTransferFormField(
  draft: Draft<TransferForm>,
  path: TransferFormFieldPath,
  value: TransferFormFieldValue
): void {
  draft[path] = value as never
}

export function clearTransferFormErrors(
  errors: TransferFormErrorMap,
  paths: TransferFormFieldPath | readonly TransferFormFieldPath[]
): TransferFormErrorMap {
  const next = { ...errors }
  delete next.root
  const fieldPaths = isArray(paths) ? paths : [paths]
  for (const path of fieldPaths) {
    delete next[path]
    for (const key of keys(next)) {
      if (key.startsWith(`${path}.`)) delete next[key]
    }
  }
  return next
}
